export default {
    isLogged: (state) => state.auth_user != null && state.auth_token != null,
    userData: (state) => state.auth_user,
    stateModal: (state) => state.stateModal,
    stateModalNumber: (state) => state.stateModalNumber,
    employee: (state) => state.employee,
    employeeActiveCode: (state) => state.employeeActiveCode,
    getPreferred: (state) => state.getPreferred
}